<template>
  <div class="login-page">
    <section class="login-shell">
      <div class="brand-hero" :style="{ '--hero-bg': `url(${bgUrl})` }">
        <img class="brand-logo" :src="logoUrl" alt="AGROAIR Technology" />
      </div>
      <div class="login-form">
        <img class="Prediberry-logo" :src="iconregistro" alt="Prediberry" />
        <form @submit.prevent="handleLogin">
          <div v-if="errorMessage" class="error-message">
            {{ errorMessage }}
          </div>

          <div class="form-group">
            <input
              type="text"
              placeholder="Nombre de usuario"
              class="form-control"
              name="username"
              v-model="username"
              autocomplete="username"
              :disabled="isLoading"
              required
            />
          </div>
          <div class="form-group password-group">
            <input
              :type="showPassword ? 'text' : 'password'"
              placeholder="Contraseña"
              class="form-control password-input"
              name="password"
              v-model="password"
              autocomplete="current-password"
              :disabled="isLoading"
              required
            />
            <button
              type="button"
              class="toggle-pass"
              @click="showPassword = !showPassword"
              :aria-label="
                showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'
              "
              :title="
                showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'
              "
            >
              <span v-if="!showPassword">🚫</span>
              <span v-else>👁️</span>
            </button>
          </div>
          <button type="submit" class="btn btn-primary" :disabled="isLoading">
            <span v-if="isLoading">Cargando...</span>
            <span v-else>Entrar</span>
          </button>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import "@/assets/css/login.css";
import logoUrl from "@/assets/icon/agroair_blancov2.png";
import bgUrl from "@/assets/icon/fondoo_logo.png";
import iconregistro from "@/assets/icon/prediberry.png";
import { invalidateCache } from "@/services/offlineService";

export default {
  name: "LoginPage",
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
      isLoading: false,
      errorMessage: "",
      logoUrl,
      bgUrl,
      iconregistro,
    };
  },
  methods: {
    async handleLogin() {
      if (!this.username || !this.password) {
        this.errorMessage = "Por favor, completa todos los campos";
        return;
      }

      this.isLoading = true;
      this.errorMessage = "";

      try {
        const response = await this.$http.post(this.$hostname + "/api/token/", {
          username: this.username,
          password: this.password,
        });

        const token = response.data.access;
        const refreshToken = response.data.refresh;
        localStorage.setItem("token", token);
        localStorage.setItem("username", this.username);
        if (refreshToken) {
          localStorage.setItem("refresh_token", refreshToken);
        }
        // Extraer is_staff del payload del JWT
        try {
          const payload = JSON.parse(atob(token.split(".")[1]));
          localStorage.setItem("is_staff", payload.is_staff ? "true" : "false");
        } catch (e) {
          localStorage.setItem("is_staff", "false");
        }
        this.$http.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        // Limpiar caché de sesión anterior para no servir datos de otro usuario
        await invalidateCache();

        // Redirecciona y luego recarga la página
        this.$router.push("/production").then(() => {
          window.location.reload();
        });
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.errorMessage =
            "Credenciales inválidas. Por favor, inténtalo de nuevo.";
        } else {
          this.errorMessage =
            "Error de conexión. Por favor, intenta nuevamente.";
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    document.body.classList.add("login-view");
  },
  beforeUnmount() {
    document.body.classList.remove("login-view");
  },
};
</script>
